/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Location } from './Location';
import {
    LocationFromJSON,
    LocationFromJSONTyped,
    LocationToJSON,
    LocationToJSONTyped,
} from './Location';

/**
 * A calendar of shifts for a particular location
 * @export
 * @interface Schedule
 */
export interface Schedule {
    /**
     * 
     * @type {number}
     * @memberof Schedule
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof Schedule
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof Schedule
     */
    defaultLocationId: number;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    name: string;
    /**
     * The status of the entity.
     * @type {string}
     * @memberof Schedule
     */
    status: ScheduleStatusEnum;
    /**
     * 
     * @type {Location}
     * @memberof Schedule
     */
    defaultLocation?: Location;
}

/**
* @export
* @enum {string}
*/
export enum ScheduleStatusEnum {
    Active = 'Active',
    Archived = 'Archived',
    Deleted = 'Deleted'
}


/**
 * Check if a given object implements the Schedule interface.
 */
export function instanceOfSchedule(value: object): value is Schedule {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('defaultLocationId' in value) || value['defaultLocationId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function ScheduleFromJSON(json: any): Schedule {
    return ScheduleFromJSONTyped(json, false);
}

export function ScheduleFromJSONTyped(json: any, ignoreDiscriminator: boolean): Schedule {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'defaultLocationId': json['defaultLocationId'],
        'name': json['name'],
        'status': json['status'],
        'defaultLocation': json['defaultLocation'] == null ? undefined : LocationFromJSON(json['defaultLocation']),
    };
}

  export function ScheduleToJSON(json: any): Schedule {
      return ScheduleToJSONTyped(json, false);
  }

  export function ScheduleToJSONTyped(value?: Schedule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'defaultLocationId': value['defaultLocationId'],
        'name': value['name'],
        'status': value['status'],
        'defaultLocation': LocationToJSON(value['defaultLocation']),
    };
}

